export default "//cloud.imgsmail.ru/cloud.mail.ru/126090/img/build/subscriptions/cancel-autorenew.png";